'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceWidgets = function DeviceWidgets(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z' })
  );
};
DeviceWidgets = (0, _pure2.default)(DeviceWidgets);
DeviceWidgets.displayName = 'DeviceWidgets';
DeviceWidgets.muiName = 'SvgIcon';

exports.default = DeviceWidgets;


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/svg-icons/device/widgets.js
 ** module id = 1722
 ** module chunks = 3
 **/